import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useForm } from "react-hook-form";
import {
  PaziaButton,
  PaziaFormButton,
  PaziaInput,
  PaziaTextarea,
} from "components/atoms";

export const CreateTermsForm = ({
  onSubmit,
  onCancel,
}: {
  onCancel: () => void;
  onSubmit: (values: CourseTermsFormValues) => Promise<void>;
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  const { handleSubmit, reset } = methods;

  const onSubmitHandler = async (values: CourseTermsFormValues) => {
    await onSubmit(values);
    reset();
  };
  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmitHandler)}>
        <PaziaInput required label="Nazwa" name={FORM_NAMES.NAME} />
        <PaziaTextarea label="Opis" name={FORM_NAMES.DESCRIPTION} />
        <PaziaInput required type="file" label="Plik" name={FORM_NAMES.TERMS} />
        <div className="ml-auto flex gap-2">
          <PaziaButton title="Anuluj" type="tertiary" btnType="button" onClick={onCancel} />
          <PaziaFormButton type="success">Zapisz</PaziaFormButton>
        </div>
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  NAME: "name",
  TERMS: "terms",
  DESCRIPTION: "description",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NAME]: yup.string().required(),
    [FORM_NAMES.DESCRIPTION]: yup.string().nullable(),
    [FORM_NAMES.TERMS]: yup.mixed().required(),
  })
  .required();

export type CourseTermsFormValues = yup.InferType<typeof schema>;
